import React from 'react';
import {Translate} from '../../config/TranslationProvider';
import {extractDate} from '../../helper';

const weekdays = {
    1: 'monday',
    2: 'tuesday',
    3: 'wednesday',
    4: 'thursday',
    5: 'friday',
    6: 'saturday',
    7: 'sunday',
};

const OpeningHours = ({openingTimes}) => {
    const specialOpeningTimes = {};
    const defaultOpeningTimes = {};

    const specialDays = openingTimes.filter(time => time.weekday === 0);
    specialDays.forEach(time => {
        const startHour = time.start;
        const endHour = time.end;
        const date = time.date;

        if (specialOpeningTimes[date]) {
            specialOpeningTimes[date].start_end.push({startHour, endHour});
        } else {
            specialOpeningTimes[date] = {
                date: date,
                start_end: [{startHour, endHour}]
            };
        }
    });

    const OpeningTimes = openingTimes.filter(time => time.weekday !== 0);
    OpeningTimes.forEach(time => {
        const startHour = time.start;
        const endHour = time.end;
        const weekday = time.weekday;

        if (defaultOpeningTimes[weekday]) {
            defaultOpeningTimes[weekday].start_end.push({startHour, endHour});
        } else {
            defaultOpeningTimes[weekday] = {
                weekday: weekday,
                start_end: [{startHour, endHour}]
            };
        }
    });

    return (
        <div className="widget atbd_widget widget-card">
            <div className="atbd_widget_title">
                <h4>
                    <span className="la la-clock-o" />&nbsp;
                    <span>
                        <Translate value="opening_hours" />
                    </span>
                </h4>
            </div>
            <div className="directory_open_hours">

                <ul>
                    {
                        Object.values(defaultOpeningTimes).map((defaultTime, key) =>
                            <li key={key} className="atbd_open">
                                <span>
                                    <Translate value={weekdays[defaultTime.weekday]} />
                                </span>
                                <span>
                                    {defaultTime.start_end.map((hour, index) =>
                                        <div key={index}>
                                            {hour.startHour + ' - ' + hour.endHour}
                                        </div>
                                    )}
                                </span>
                            </li>
                        )
                    }
                </ul>

                {Object.values(specialOpeningTimes).length > 0 &&
                    <>
                        <ul style={{marginTop: 20, paddingBottom: 10, borderBottom: '1px solid #e3e6ef',}}>
                            <li className="atbd_open">
                                <span style={{fontWeight: 700}}>
                                    <Translate value="special_opening_hours" />
                                </span>
                            </li>
                        </ul>
                        <ul style={{marginTop: '20px'}}>
                            {
                                Object.values(specialOpeningTimes).map((specialTime, key) =>
                                    <li key={key} className="atbd_open">
                                        <span>{extractDate(specialTime.date)}</span>
                                        <span>
                                            {specialTime.start_end.map((hour, index) =>
                                                <div key={index}>
                                                    {hour.startHour + ' - ' + hour.endHour}
                                                </div>
                                            )}
                                        </span>
                                    </li>
                                )
                            }
                        </ul>
                    </>
                }

            </div>
        </div>
    );
};

export default OpeningHours;
